/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Copilot_Sync_DescriptionInputs */



/**
* | output |
* | --- |
* | "Run compliance checks before responding. Enables blocking but adds a short delay." |
*
* @param {Compliance_Copilot_Sync_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_copilot_sync_description = /** @type {((inputs?: Compliance_Copilot_Sync_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Copilot_Sync_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance-Prüfungen vor der Antwort ausführen. Ermöglicht Blockierung, fügt aber eine kurze Verzögerung hinzu.")
	return /** @type {LocalizedString} */ ("Run compliance checks before responding. Enables blocking but adds a short delay.")
});